// src/components/cognition/consensus-indicator.tsx
import React from "react";
import { AlertTriangle, CheckCircle2, Minus } from "lucide-react";

function titleCase(s: string) {
  const v = String(s || "").trim();
  if (!v) return "—";
  return v[0].toUpperCase() + v.slice(1).toLowerCase();
}

export function ConsensusIndicator({ consensus }: { consensus: string }) {
  const c = String(consensus || "").toLowerCase();

  const getConsensusStyle = () => {
    if (c === "strong") {
      return {
        label: "Strong",
        bg: "var(--success-bg)",
        text: "var(--success-text)",
        border: "var(--success-border)",
        icon: <CheckCircle2 className="w-3 h-3" />,
      };
    }

    if (c === "moderate" || c === "medium") {
      return {
        label: "Moderate",
        bg: "rgba(245, 158, 11, 0.10)",
        text: "rgba(245, 158, 11, 1)",
        border: "rgba(245, 158, 11, 0.35)",
        icon: <Minus className="w-3 h-3" />,
      };
    }

    if (c === "weak" || c === "divergent") {
      return {
        label: titleCase(consensus || "Divergent"),
        bg: "var(--infrared-coral-5)",
        text: "var(--infrared-coral)",
        border: "var(--infrared-coral)",
        icon: <AlertTriangle className="w-3 h-3" />,
      };
    }

    return {
      label: titleCase(consensus || "—"),
      bg: "var(--muted)",
      text: "var(--muted-foreground)",
      border: "var(--border)",
      icon: <Minus className="w-3 h-3" />,
    };
  };

  const style = getConsensusStyle();

  return (
    <div
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded"
      style={{ backgroundColor: style.bg, border: `1px solid ${style.border}` }}
    >
      <div style={{ color: style.text }}>{style.icon}</div>
      <span style={{ fontSize: "var(--text-sm)", fontWeight: "var(--font-weight-semibold)", color: style.text }}>
        {style.label}
      </span>
    </div>
  );
}
